module.exports = __webpack_public_path__ + "img/newicon1.40f981c4.png";